import React from "react";
import PropTypes from "prop-types";
import {
  PromotionDropdownButtonImageClosed,
  PromotionDropdownButtonImageOpen
} from "components/Images/PromotionDropdownButtonIcons";

export const PromotionDropdownButtonClosed = ({ toggleDropdown }) => {
  return (
    <>
      <button
        type="button"
        className="promotionDropdownButton--closed"
        id="promotionDropdownButtonClosed"
        onClick={() => {
          toggleDropdown();
        }}
      >
        <PromotionDropdownButtonImageClosed
          className="promotion__button--closed"
          id="promotionDropdownButtonImageClosed"
        />
        Have a Promotion Code?
      </button>
    </>
  );
};

PromotionDropdownButtonClosed.propTypes = {
  toggleDropdown: PropTypes.func.isRequired
};

export const PromotionDropdownButtonOpen = ({ toggleDropdown }) => {
  return (
    <>
      <button
        type="button"
        className="promotionDropdownButton--open"
        id="promotionDropdownButtonOpen"
        onClick={() => {
          toggleDropdown();
        }}
      >
        <PromotionDropdownButtonImageOpen
          className="promotion__button--open"
          id="promotionDropdownButtonImageOpen"
        />
        Have a Promotion Code?
      </button>
    </>
  );
};

PromotionDropdownButtonOpen.propTypes = {
  toggleDropdown: PropTypes.func.isRequired
};
